import React from 'react'

import './MonsterCard.css'

const MonsterCard = props => {
  const { image, name } = props

  if (!image) {
    return null
  }

  const portrait = `/api/pfsrd2/images/Monsters/${image}`

  return (
    <div className='MonsterCard'>
      <a href={portrait} target='_blank'>
        <img
          src={portrait}
          className='MonsterCard__portrait MonsterCard__portrait--party'
        />
      </a>
      <div className='MonsterCard__name'>{name}</div>
    </div>
  )
}

export default MonsterCard
